import { Component, Input } from '@angular/core';
import { TitleTextPipe } from '@app/shared/pipes/title-text.pipe';

@Component({
    selector: 'rn-status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.scss'],
    standalone: true,
    imports: [TitleTextPipe]
})
export class StatusComponent {
  @Input() status: string;

  constructor() { }

  statusClasses() {
    return `status status--${this.status}`;
  }
}
